import { render, staticRenderFns } from "./PremiumHintModal.vue?vue&type=template&id=558e391c&scoped=true"
import script from "./PremiumHintModal.vue?vue&type=script&lang=js"
export * from "./PremiumHintModal.vue?vue&type=script&lang=js"
import style0 from "./PremiumHintModal.vue?vue&type=style&index=0&id=558e391c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558e391c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
